<template>
  <div v-if="show" class="candidate-additional-info-container" :class="hasResumeView ? 'has-resume-view' : ''">
    <WrappedForm
      ref="form"
      class="candidate-additional-info"
      label-width="200px"
      :model="stepData"
      :formLines="formLines"
    >
    </WrappedForm>
    <RectLoading v-show="loading" class="loading"></RectLoading>
  </div>
</template>

<script>
import mixin from './mixin'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import RectLoading from '@/components/loading/rectLoading.vue'

export default {
  mixins: [mixin],
  components: {
    WrappedForm,
    RectLoading
  },
  props: {
    hasResumeView: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      stepData: { }
    }
  },
  computed: {
    formLines () {
      const lines = {
        professionalMemberShip: {
          label: this.$t(`${this.i18nPrefix}.label.professionalMemberShip`),
          placeholder: this.$t(`${this.i18nPrefix}.placeholder.professionalMemberShip`),
          props: { type: 'textarea', autosize: { minRows: 5 } }
        },
        awards: {
          label: this.$t(`${this.i18nPrefix}.label.awards`),
          placeholder: this.$t(`${this.i18nPrefix}.placeholder.awards`),
          props: { type: 'textarea', autosize: { minRows: 5 } }
        },
        hobbies: {
          label: this.$t(`${this.i18nPrefix}.label.hobbies`),
          placeholder: this.$t(`${this.i18nPrefix}.placeholder.hobbies`),
          props: { type: 'textarea', autosize: { minRows: 5 } }
        }
      }
      return lines
    }
  },
  methods: {
    async setStepDataToCandidateInfo () {
      const stepData = this.stepData
      const candidateInfo = this.candidateInfo
      this.$set(candidateInfo, 'additionalInfo', {
        professionalMemberShip: stepData.professionalMemberShip,
        awards: stepData.awards,
        hobbies: stepData.hobbies
      })
    },
    async getStepData () {
      const additionalInfo = this.candidateInfo.additionalInfo
      const stepData = {
        professionalMemberShip: additionalInfo?.professionalMemberShip,
        awards: additionalInfo?.awards,
        hobbies: additionalInfo?.hobbies
      }

      return stepData
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-additional-info-container {

  .candidate-additional-info {

    .span-info {
      color: #606266;
    }

  }
}

.has-resume-view {
  .candidate-additional-info {}

  ::v-deep {
    .el-form-item__label {
      font-size: 12px;
    }
    .label-inner {
      font-size: 12px;
    }

    .el-textarea__inner {
      font-size: 12px;
    }
  }
}
</style>
